import { take } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddPropertyModalComponent } from '@clients/components/modals/add-property-modal/add-property-modal.component';
import { EditPropertyModalComponent } from '@clients/components/modals/edit-property-modal/edit-property-modal.component';
import { IClientForm } from '@clients/models/domain/client.domain';
import { IClientProperty } from '@clients/models/firebase/client.model';
import { PhoneNumberControlComponent } from '@shared/components/forms/phone-number-control/phone-number-control.component';
import { StandardControlComponent } from '@shared/components/forms/standard-control/standard-control.component';
import { TextareaControlComponent } from '@shared/components/forms/textarea-control/textarea-control.component';
import { AccordionItemComponent } from '@shared/components/ui/accordion-item/accordion-item.component';
import { AccordionComponent } from '@shared/components/ui/accordion/accordion.component';
import { PropertyPipe } from '@shared/pipes/property.pipe';
import { ModalService } from '@shared/services/modal/modal.service';

@Component({
	selector: 'app-mobile-client-create-details',
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		AccordionComponent,
		AccordionItemComponent,
		StandardControlComponent,
		TextareaControlComponent,
		PhoneNumberControlComponent,
		PropertyPipe,
	],
	templateUrl: './mobile-client-create-details.component.html',
	styleUrl: './mobile-client-create-details.component.scss',
})
export class MobileClientCreateDetailsComponent {
	@Input() clientForm: FormGroup<IClientForm>;
	@Input() properties: Array<IClientProperty>;
	private modalService = inject(ModalService);

	openAddProperty(): void {
		const modalRef = this.modalService.open(AddPropertyModalComponent);
		const componentInstance = modalRef.componentInstance as AddPropertyModalComponent;
		componentInstance.propertySelected.pipe(take(1)).subscribe((property: IClientProperty) => {
			this.properties.push(property);
		});
	}

	openEditProperty(clientProperty: IClientProperty, index: number): void {
		const modalRef = this.modalService.open(EditPropertyModalComponent);
		const componentInstance = modalRef.componentInstance as EditPropertyModalComponent;
		componentInstance.clientProperty = clientProperty;
		componentInstance.propertySelected.pipe(take(1)).subscribe((property: IClientProperty) => {
			this.properties[index] = property;
		});
		componentInstance.propertyRemoved.pipe(take(1)).subscribe(() => {
			this.properties.splice(index, 1);
		});
	}
}
